import { useEffect, useState } from 'react';
import { useImpersonationService } from '../services/impersonationService';

/**
 * Whether the Users page (impersonation, #790) is switched on, asked once for a Super Admin. Anyone else, a
 * switched-off server, or a config that cannot be read keeps the entry hidden.
 */
export const useImpersonationEnabled = isSuperAdmin => {
    const { getConfig } = useImpersonationService();
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        if (!isSuperAdmin) {
            return undefined;
        }

        let active = true;
        getConfig()
            .then(config => active && setEnabled(Boolean(config?.enabled)))
            .catch(() => active && setEnabled(false));

        return () => {
            active = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuperAdmin]);

    return enabled;
};
